import { PaymentTypes } from '@grandvisionhq/api-client';
import { PaymentMethod } from '@grandvisionhq/payments';

/**
 * The getRestPaymentMethodName function is being used to CONVERT the name of
 * the `payment method`, that is fetched by the getCartPaymentMethods query
 * TO the `payment method` name of the legacy api-client.
 *
 * @param {PaymentMethod} name - The name of the payment method.
 */ const getRestPaymentMethodName = (name)=>{
    switch(name){
        case PaymentMethod.BANCONTACT_CARD:
            return PaymentTypes.PaymentMethod.BancontactCard;
        case PaymentMethod.BANCONTACT_MOBILE:
            return PaymentTypes.PaymentMethod.BancontactMobile;
        case PaymentMethod.CASH_ON_DELIVERY:
            return PaymentTypes.PaymentMethod.CashOnDelivery;
        case PaymentMethod.CREDITCARD:
            return PaymentTypes.PaymentMethod.Creditcard;
        case PaymentMethod.FAKE:
            return PaymentTypes.PaymentMethod.Fake;
        case PaymentMethod.IDEAL:
            return PaymentTypes.PaymentMethod.Ideal;
        case PaymentMethod.KLARNA:
            return PaymentTypes.PaymentMethod.Klarna;
        case PaymentMethod.KLARNA_ACCOUNT:
            return PaymentTypes.PaymentMethod.KlarnaAccount;
        case PaymentMethod.MBWAY:
            return PaymentTypes.PaymentMethod.MBway;
        case PaymentMethod.MOBILE_PAY:
            return PaymentTypes.PaymentMethod.MobilePay;
        case PaymentMethod.MULTIBANCO:
            return PaymentTypes.PaymentMethod.Multibanco;
        case PaymentMethod.ONEY:
            return PaymentTypes.PaymentMethod.Oney;
        case PaymentMethod.PAYPAL:
            return PaymentTypes.PaymentMethod.Paypal;
        case PaymentMethod.SEPA_DIRECT_DEBIT:
            return PaymentTypes.PaymentMethod.SepaDirectDebit;
        case PaymentMethod.SWISH:
            return PaymentTypes.PaymentMethod.Swish;
        case PaymentMethod.APPLE_PAY:
            return PaymentTypes.PaymentMethod.ApplePay;
        default:
            return undefined;
    }
};
/**
 * The getGraphQLPaymentMethodName function is being used to CONVERT the name of
 * the `payment method`, that is received by the `createOrder` POST request
 * TO the `payment method` name of new getCartPaymentMethods query.
 *
 * @param {PaymentMethod} name - The name of the payment method.
 */ const getGraphQLPaymentMethodName = (name)=>{
    switch(name){
        case PaymentTypes.PaymentMethod.BancontactCard:
            return PaymentMethod.BANCONTACT_CARD;
        case PaymentTypes.PaymentMethod.BancontactMobile:
            return PaymentMethod.BANCONTACT_MOBILE;
        case PaymentTypes.PaymentMethod.CashOnDelivery:
            return PaymentMethod.CASH_ON_DELIVERY;
        case PaymentTypes.PaymentMethod.Creditcard:
            return PaymentMethod.CREDITCARD;
        case PaymentTypes.PaymentMethod.Fake:
            return PaymentMethod.FAKE;
        case PaymentTypes.PaymentMethod.Ideal:
            return PaymentMethod.IDEAL;
        case PaymentTypes.PaymentMethod.Klarna:
            return PaymentMethod.KLARNA;
        case PaymentTypes.PaymentMethod.KlarnaAccount:
            return PaymentMethod.KLARNA_ACCOUNT;
        case PaymentTypes.PaymentMethod.MBway:
            return PaymentMethod.MBWAY;
        case PaymentTypes.PaymentMethod.MobilePay:
            return PaymentMethod.MOBILE_PAY;
        case PaymentTypes.PaymentMethod.Multibanco:
            return PaymentMethod.MULTIBANCO;
        case PaymentTypes.PaymentMethod.Oney:
            return PaymentMethod.ONEY;
        case PaymentTypes.PaymentMethod.Paypal:
            return PaymentMethod.PAYPAL;
        case PaymentTypes.PaymentMethod.SepaDirectDebit:
            return PaymentMethod.SEPA_DIRECT_DEBIT;
        case PaymentTypes.PaymentMethod.Swish:
            return PaymentMethod.SWISH;
        case PaymentTypes.PaymentMethod.ApplePay:
            return PaymentMethod.APPLE_PAY;
        default:
            return undefined;
    }
};

export { getGraphQLPaymentMethodName, getRestPaymentMethodName };
//# sourceMappingURL=get-payment-method-name.js.map
